import { useCallback } from 'react';
import { useStore } from 'react-redux';
import Context from 'managers/Context';
import {
    MARKETING_STATUS,
    fetchMarketingStatusList,
    resolveMarketingStatusIdFromList,
} from 'components/TableCells/MarketingStatusCell';
import { getSelectionFilters, getSelectionIdsFromListSelect } from 'utils/bulkSelection';

export default function useGiveConsent() {
    const store = useStore();

    const giveConsent = useCallback(
        (entity, filterKey) => {
            const state = store.getState();
            const entityListSelect = state.entityListSelect[entity.entity];
            const [includedIds, excludedIds] = getSelectionIdsFromListSelect(entityListSelect);
            const { crossFilters, filter, operators } = getSelectionFilters(
                state,
                entity,
                filterKey,
            );

            const runBulk = (subscribedId) =>
                Context.bulkManager.startBulk({
                    entityName: entity.extraFieldTab.toLowerCase(),
                    operation: 'update',
                    data: JSON.stringify({
                        marketingStatusId: subscribedId,
                    }),
                    includedIds,
                    excludedIds,
                    filter,
                    operators,
                    crossFilters,
                });

            return fetchMarketingStatusList(store.dispatch).then((rows) => {
                const subscribedId = resolveMarketingStatusIdFromList(
                    rows,
                    MARKETING_STATUS.SUBSCRIBED,
                );
                return runBulk(subscribedId).then((response) => ({ response, subscribedId }));
            });
        },
        [store],
    );

    return giveConsent;
}
